import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../../store/adminSlice";

/**
 * Shown under the app header whenever a SUPER_ADMIN is viewing another store.
 * Exit clears sessionStorage.debugShop so the next API call uses the admin's own shop.
 */
const ImpersonationBanner = () => {
  const dispatch = useDispatch();
  const { debugShop } = useSelector((state) => state.admin);

  if (!debugShop) return null;

  const onExit = () => {
    dispatch(adminActions.clearDebugShop());
    window.location.reload();
  };

  return (
    <div
      style={{
        background: "#ffe0e0",
        padding: "10px 16px",
        textAlign: "center",
        borderBottom: "1px solid #e0a0a0",
      }}
    >
      ⚠ Viewing: {debugShop}{" "}
      <button onClick={onExit}>Exit</button>
    </div>
  );
};

export default ImpersonationBanner;
